import { IncentiveListAction, CheckedEntry } from '../actions/incentiveList'
import { AggregateResponse } from '../api/incentiveListApi'

// 特典付与代行リストモーダルのstate
export interface IncentiveListState {
  modalOpen: boolean
  loading: boolean
  error: string | null
  entries: CheckedEntry[]
  unmatched: AggregateResponse['unmatched']
  skipped: AggregateResponse['skipped']
  // 集約対象となったtokey一覧（CV一覧の絞り込み表示に使う）
  matchedTokeys: string[] | null
  // 集約対象cv_reportの行データ（期間フィルタ非依存）
  cvRows: Record<string, any>[] | null
  // CSV由来のフォールバック友人メール（tokey => email）
  csvFriendEmails: Record<string, string>
}

const initialState: IncentiveListState = {
  modalOpen: false,
  loading: false,
  error: null,
  entries: [],
  unmatched: [],
  skipped: [],
  matchedTokeys: null,
  cvRows: null,
  csvFriendEmails: {},
}

const reducer = (
  state: IncentiveListState = initialState,
  action: IncentiveListAction,
): IncentiveListState => {
  switch (action.type) {
    case 'INCENTIVE_LIST_OPEN_MODAL': {
      return { ...state, modalOpen: true, error: null }
    }
    case 'INCENTIVE_LIST_CLOSE_MODAL': {
      // モーダルを閉じる。集約結果（matched/cvRows/entries等）はバナー表示・DL用に保持
      return { ...state, modalOpen: false }
    }
    case 'INCENTIVE_LIST_SET_LOADING': {
      return { ...state, loading: action.loading }
    }
    case 'INCENTIVE_LIST_SET_ERROR': {
      return { ...state, error: action.error }
    }
    case 'INCENTIVE_LIST_SET_RESULT': {
      // 集約結果を取り込む。デフォルトで全行チェック済み
      // csv_friend_emailsはCSVアップロード由来のもののみ保持（再集約時はマージしない）
      const newCsvFriendEmails =
        action.payload.csv_friend_emails &&
          Object.keys(action.payload.csv_friend_emails).length > 0
          ? action.payload.csv_friend_emails
          : state.csvFriendEmails
      return {
        ...state,
        entries: action.payload.entries.map((e) => ({ ...e, checked: true })),
        unmatched: action.payload.unmatched || [],
        skipped: action.payload.skipped || [],
        matchedTokeys: action.payload.matched_tokeys || [],
        cvRows: action.payload.cv_rows || [],
        csvFriendEmails: newCsvFriendEmails,
      }
    }
    case 'INCENTIVE_LIST_CLEAR_MATCHED': {
      // CV一覧の絞り込みを解除し、関連state全体をクリア
      return initialState
    }
    case 'INCENTIVE_LIST_TOGGLE_ENTRY': {
      // 指定インデックスのチェック状態だけ反転
      return {
        ...state,
        entries: state.entries.map((e, i) =>
          i === action.index ? { ...e, checked: !e.checked } : e,
        ),
      }
    }
    case 'INCENTIVE_LIST_SET_ALL_CHECKED': {
      return {
        ...state,
        entries: state.entries.map((e) => ({ ...e, checked: action.checked })),
      }
    }
    default:
      return state
  }
}

export default reducer
